/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsGroupReference,
    ElementsGroupReferenceFromJSON,
    ElementsGroupReferenceFromJSONTyped,
    ElementsGroupReferenceToJSON,
    ElementsUserReference,
    ElementsUserReferenceFromJSON,
    ElementsUserReferenceFromJSONTyped,
    ElementsUserReferenceToJSON,
    ScheduleReference,
    ScheduleReferenceFromJSON,
    ScheduleReferenceFromJSONTyped,
    ScheduleReferenceToJSON,
    SubtaskReference,
    SubtaskReferenceFromJSON,
    SubtaskReferenceFromJSONTyped,
    SubtaskReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface JobUpdate
 */
export interface JobUpdate {
    /**
     * 
     * @type {Array<SubtaskReference>}
     * @memberof JobUpdate
     */
    subtasks?: Array<SubtaskReference>;
    /**
     * 
     * @type {Array<ScheduleReference>}
     * @memberof JobUpdate
     */
    schedules?: Array<ScheduleReference>;
    /**
     * 
     * @type {Array<ElementsUserReference>}
     * @memberof JobUpdate
     */
    allowUsers?: Array<ElementsUserReference>;
    /**
     * 
     * @type {Array<ElementsGroupReference>}
     * @memberof JobUpdate
     */
    allowGroups?: Array<ElementsGroupReference>;
    /**
     * 
     * @type {Array<{ [key: string]: string | undefined; }>}
     * @memberof JobUpdate
     */
    variableDefinitions?: Array<{ [key: string]: string | undefined; }>;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobUpdate
     */
    mediaRoots?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof JobUpdate
     */
    specialType?: JobUpdateSpecialTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof JobUpdate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof JobUpdate
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobUpdate
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobUpdate
     */
    allowOthersToStart?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobUpdate
     */
    allowClientToStart?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobUpdate
     */
    showAsButton?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobUpdate
     */
    inputType?: JobUpdateInputTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof JobUpdate
     */
    addToNewMediaRoots?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobUpdate
     */
    hook?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobUpdate
     */
    webhookSecret?: string | null;
    /**
     * 
     * @type {number}
     * @memberof JobUpdate
     */
    securityContext?: number | null;
    /**
     * 
     * @type {number}
     * @memberof JobUpdate
     */
    partOfWorkflowFor?: number | null;
}

/**
* @export
* @enum {string}
*/
export enum JobUpdateSpecialTypeEnum {
    NUMBER_2 = 2,
    NUMBER_3 = 3
}/**
* @export
* @enum {string}
*/
export enum JobUpdateInputTypeEnum {
    Path = 'path',
    Dir = 'dir',
    Paths = 'paths',
    Dirs = 'dirs'
}

export function JobUpdateFromJSON(json: any): JobUpdate {
    return JobUpdateFromJSONTyped(json, false);
}

export function JobUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subtasks': !exists(json, 'subtasks') ? undefined : ((json['subtasks'] as Array<any>).map(SubtaskReferenceFromJSON)),
        'schedules': !exists(json, 'schedules') ? undefined : ((json['schedules'] as Array<any>).map(ScheduleReferenceFromJSON)),
        'allowUsers': !exists(json, 'allow_users') ? undefined : ((json['allow_users'] as Array<any>).map(ElementsUserReferenceFromJSON)),
        'allowGroups': !exists(json, 'allow_groups') ? undefined : ((json['allow_groups'] as Array<any>).map(ElementsGroupReferenceFromJSON)),
        'variableDefinitions': !exists(json, 'variable_definitions') ? undefined : json['variable_definitions'],
        'mediaRoots': !exists(json, 'media_roots') ? undefined : json['media_roots'],
        'specialType': !exists(json, 'special_type') ? undefined : json['special_type'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'allowOthersToStart': !exists(json, 'allow_others_to_start') ? undefined : json['allow_others_to_start'],
        'allowClientToStart': !exists(json, 'allow_client_to_start') ? undefined : json['allow_client_to_start'],
        'showAsButton': !exists(json, 'show_as_button') ? undefined : json['show_as_button'],
        'inputType': !exists(json, 'input_type') ? undefined : json['input_type'],
        'addToNewMediaRoots': !exists(json, 'add_to_new_media_roots') ? undefined : json['add_to_new_media_roots'],
        'hook': !exists(json, 'hook') ? undefined : json['hook'],
        'webhookSecret': !exists(json, 'webhook_secret') ? undefined : json['webhook_secret'],
        'securityContext': !exists(json, 'security_context') ? undefined : json['security_context'],
        'partOfWorkflowFor': !exists(json, 'part_of_workflow_for') ? undefined : json['part_of_workflow_for'],
    };
}

export function JobUpdateToJSON(value?: JobUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subtasks': value.subtasks === undefined ? undefined : ((value.subtasks as Array<any>).map(SubtaskReferenceToJSON)),
        'schedules': value.schedules === undefined ? undefined : ((value.schedules as Array<any>).map(ScheduleReferenceToJSON)),
        'allow_users': value.allowUsers === undefined ? undefined : ((value.allowUsers as Array<any>).map(ElementsUserReferenceToJSON)),
        'allow_groups': value.allowGroups === undefined ? undefined : ((value.allowGroups as Array<any>).map(ElementsGroupReferenceToJSON)),
        'variable_definitions': value.variableDefinitions,
        'media_roots': value.mediaRoots,
        'special_type': value.specialType,
        'name': value.name,
        'description': value.description,
        'enabled': value.enabled,
        'allow_others_to_start': value.allowOthersToStart,
        'allow_client_to_start': value.allowClientToStart,
        'show_as_button': value.showAsButton,
        'input_type': value.inputType,
        'add_to_new_media_roots': value.addToNewMediaRoots,
        'hook': value.hook,
        'webhook_secret': value.webhookSecret,
        'security_context': value.securityContext,
        'part_of_workflow_for': value.partOfWorkflowFor,
    };
}


